import { Component, OnInit, Input, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MainMenu } from '../main-menu-item.interface';
import { CartService } from '../cart.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AsyncPipe, JsonPipe } from '@angular/common';

@Component({
    selector: 'tea-shop-fe-top-navigation',
    templateUrl: './top-navigation.component.html',
    styleUrls: ['./top-navigation.component.css'],
    imports: [RouterLink, RouterLinkActive, AsyncPipe, JsonPipe]
})
export class TopNavigationComponent implements OnInit {
  private cartService = inject(CartService);

  @Input() mainMenu$!: Observable<MainMenu>;
  cartItemCount$!: Observable<number>;

  showDropdown: { [key: string]: boolean } = {};

  ngOnInit() {
    this.cartItemCount$ = this.cartService.getCartItemCount();
  }

  closeDropdowns(event: Event, exceptItem: string | null) {
    event.stopPropagation();
    Object.keys(this.showDropdown).forEach((key) => {
      if (key !== exceptItem /* && key !== 'mobileMenu' */) { // I think we want the mobile menu to close when we click on a link
        this.showDropdown[key] = false;
      }
    });
    window.scrollTo(0, 0); // TODO : Need to do this the angular way with a dependency injection
  }
}
